import { LocationsProperty, PropertyWithOccupants } from '@centecomm/portal-service';

export default ({ id, name, occupants }: LocationsProperty): PropertyWithOccupants => ({
    id,
    name,
    occupants,
});
